import type {FC} from 'react';
import {CommonLink} from '../../../../../shared/components/CommonLink';

type Props = {
  id: string;
  sectionTitle: string;
  companyID?: number;
  showEntrysheetAndReport?: boolean;
};

export const SectionTitle: FC<Props> = ({
  id,
  sectionTitle,
  companyID,
  showEntrysheetAndReport,
}) => {
  return (
    <div className="flex justify-between items-center bg-white px-16 py-8 pc:p-24 rounded-t-[12px] rounded-b-[4px]">
      <h2 id={id} className="text-lg pc:text-xl font-bold text-black">
        {sectionTitle}
      </h2>
      {showEntrysheetAndReport ? (
        <CommonLink
          className="hidden pc:block bg-deadline-primary px-16 py-8 rounded-[24px] text-primary bg-white font-bold border-[2px] border-primary"
          href={`/company/${companyID}/experiences`}
        >
          ES・体験記をみる
        </CommonLink>
      ) : null}
    </div>
  );
};
